<template>
	<div id="appbox">
		<div class="top_heard">
				<div class="top_box" v-if="screenWidth>785" >
					<div class="logo_box"  @click="gohome()">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					
					<div class="top_search_box">
						<div class="top_search">
							<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
							  <el-option
							    v-for="item in options"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value">
							  </el-option>
							</el-select>
							<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
							<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="getlist()" alt="" srcset="">
						</div>
						  
					</div>
					
				</div>
				<div class="top_tab_box">
					<van-nav-bar title="" style="color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true" v-if="screenWidth<785" >
						<template #left>
							<div class="vannav_title" style="color: #217495;font-size: 16px;" >
								基地列表
							</div>
						</template>
						<template #title>
							<div class="vannav_title" style="width: 180px;padding: 20px;">
									<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
							</div>
						</template>
					  <template #right>
						  <van-icon name="ellipsis"  size="20"    />
					  </template>
					</van-nav-bar>
					<van-popup v-model="vannavshow"  :style="{ height: '50%' }" position="top">
						<van-picker
						  title=""
						  show-toolbar
						  :columns="vannavlist"
						  confirm-button-text="进入"
						  @confirm="vanlinkgo"
						  @cancel="vannavmenushow"
						  @change="onChange"
						/>
					</van-popup>
					<div class="toptabnav" v-if="screenWidth>785" >
							<el-menu
							  :default-active="activeIndex2"
							  class="el-menu-demo"
							  mode="horizontal"
							  @select="handleSelect"
							  router
							  background-color="#FE7C2B"
							  text-color="#FFFFFF"
							  active-text-color="#FFFFFF">
							<el-menu-item index="/Home">首页</el-menu-item>
							<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
							<el-menu-item index="/Courselist" >研学课程</el-menu-item>
							<el-submenu index="/institution">
							    <template slot="title">研学机构</template>
							    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
							    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
							    <el-menu-item index="/traveler" >会员单位</el-menu-item> 
							</el-submenu>
							<el-menu-item index="/Campmap" >研学地图</el-menu-item>
							<el-menu-item index="/Activitylist">活动中心</el-menu-item>
							<el-menu-item index="/Linelist" >研学线路</el-menu-item>
							<el-submenu index="/yanxueteam">
							    <template slot="title">研学团队</template>
							    <el-menu-item index="/mentorlist" >研学导师</el-menu-item>
							    <el-menu-item index="/expertlist" >专家团队</el-menu-item>
							  </el-submenu>
							<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
						</el-menu>
					</div>
					<div class="top_banner">
						<el-carousel ref="carousel" :interval="4000"  :height="screenWidth>785?'550px':(screenWidth*551/1920)+'px'">
						  <el-carousel-item v-for="item in platelist" :key="item">
						    <h3 class="medium" style="width: 100%;height: 100%;"><img :src="item.thumb"  style="width: 100%;height: 100%;" alt="" @click="gomodules(item.link)" srcset=""></h3>
						  </el-carousel-item>
						</el-carousel>
					</div>
				<!-- 	<div class="top_plate">
						<div class="plate_item" v-for="(plate, index) in platelist" :key="plate" @mouseover="showstep(index)" @click="goplate(plate.id)" >
							<div class="plate_icon">
								<img :src="plate.icon" alt="" srcset="">
							</div>
							<div class="plate_title">
								{{plate.title}}
							</div>
						</div>
					</div> -->
				</div>
			</div>
			<div class="mobiletype_screen"  v-if="screenWidth<785">
				<van-dropdown-menu active-color="#FE7C2B">
				  <van-dropdown-item v-model="region_type" :options="vanregionlist" @change="camptypetab" />
				  <van-dropdown-item v-model="tags_type" :options="vancamptags" @change="tagstypetab" />
				</van-dropdown-menu>
			</div>
		<div class="main_box" :style="screenWidth>785?'':'width:100%;'">
			<div class="screen_box"  v-if="screenWidth>785">
				<div class="screen_items" >
					<div class="screen_title_box">
						<div class="screen_title" v-for="count in 2" :key="count">
							基地地区：
						</div>
					</div>
					<div class="" style="width: 980px;display: flex;flex-wrap: wrap;" >
						<div   :class="region_type==''?'screen_item_a':'screen_item'"  @click="camptypetab('')" >
							全部
						</div>
						<div  v-for="item in regionlist" :key="item"  :class="item.id==region_type?'screen_item_a':'screen_item'"  @click="camptypetab(item.id)" >
							{{item.title}}
						</div>
					</div>
				</div>
				<div class="screen_items" >
						<div class="screen_title_box">
							<div class="screen_title" v-for="count in 2" :key="count">
								基地标签：
							</div>
						</div>
						<div class="" style="width: 980px;display: flex;flex-wrap: wrap;" >
				<!-- 			<div   :class="region_type==''?'screen_item_a':'screen_item'"  @click="camptypetab('')" >
								全部
							</div> -->
							<div  v-for="item in camptags" :key="item"  :class="item.id==tags_type?'screen_item_a':'screen_item'"  @click="tagstypetab(item.id)" >
								{{item.title}}
							</div>
						</div>
					</div>
				<!-- <div class="screen_items">
					<div class="screen_title">
						基地地区：
					</div>
					<div   :class="region_type==''?'screen_item_a':'screen_item'"  @click="camptypetab('')" >
						全部
					</div>
					<div  v-for="item in regionlist" :key="item"  :class="item.id==region_type?'screen_item_a':'screen_item'"  @click="camptypetab(item.id)" >
						{{item.title}}
					</div>
				</div> -->
			</div>
			<div class="camplist" :style="screenWidth>785?'':'width:100%;'">
				<div class="" :style="screenWidth>785?'':'width:100%;'" v-if="!camplist.length">
					<el-empty description="当前条件没有符合的基地"></el-empty>
				</div>
				<div class="campitems" :style="screenWidth>785?'':'width:calc(100% - 30px);flex-direction: column;padding:15px;'" v-for="item in camplist" :key="item"   @click="detail(item.id)"   >
					<div class="campitem_imgbox" :style="screenWidth>785?'':'width:100%;aspect-ratio: 337/161;height:auto;'">
						<img :src="item.icon" alt="" srcset="">
						<div class="campitem_tags">
							<div class="campitem_tag" v-for="tag in item.tags" :key="tag" :style="'color:'+tag.color+';background:'+tag.background+';'" >
								{{tag.title}}
							</div>
						</div>
					</div>
					<div class="campitem_msg" :style="screenWidth>785?'':'width:100%;padding-top:15px;margin:0px;height:auto;'">
				<!-- 		<div class="campitem_msg_title" >
							<span>{{item.type}}</span>{{item.title}}
						</div> -->
						<div class="campitem_msg_title" :style="screenWidth>785?'':'width:'+(screenWidth-30)+'px;'">	
							<span>{{item.type}}</span>
							<div class="" :style="screenWidth>785?'text-align: left;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;':'text-align: left;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;font-size:16px;width:'+(screenWidth-100)+'px;'">
								{{item.title}}
							</div>
						</div>
						<div class="campitem_msg_introduce">
							<i class="el-icon-office-building" style="color:#FE7C2B ;margin-right: 10px;"></i>
							<div class="" :style="screenWidth>785?'text-align: left;':'text-align: left;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;font-size:16px;width:'+(screenWidth-60)+'px;'">
								所属单位：{{item.legal_entity}}
							</div>
						</div>
						<div class="campitem_msg_introduce">
							<i class="el-icon-timer" style="color:#FE7C2B ;margin-right: 10px;"></i>
							<div :style="screenWidth>785?'text-align: left;':'text-align: left;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;font-size:16px;width:'+(screenWidth-60)+'px;'" >开放时间：{{item.open_time}}</div>
						</div>
						<div class="campitem_msg_introduce" :style="screenWidth>785?'':'flex-wrap: wrap;'" v-if="item.conf.length">
							<i class="el-icon-date" style="color:#FE7C2B ;margin-right: 10px;"></i>
							服务设施：
							<!-- <el-tag style="margin:0px 5px;" size="mini" v-for="tag in item.conf" :key="tag" :color="tag.background" effect="dark" >{{tag.title}}</el-tag> -->
							<img v-for="tag in item.conf" :key="tag" :src="tag.icon" style="width: 27px;height: 27px;border-radius: 99px;margin-right: 10px;" alt="" srcset=""/>
						</div>
				<!-- 		<div class="campitem_msg_introduce">
							<i class="el-icon-location-information" style="color:#FE7C2B ;margin-right: 10px;"></i>所在地址：{{item.address}}
						</div> -->
						<div class="campitem_msg_button" >
							<div class="campitem_msg_introduce">
								<i class="el-icon-view" style="color:#FE7C2B ;margin-right:10px;"></i>总浏览量：<span style="color: #FE7C2B;">{{item.uv}}</span>
							</div>
							<div class="msg_button" v-if="screenWidth>785">
								查看详情
							</div>
						</div>
					</div>
				</div>
				<div class="pages_total">
					<el-pagination
					  background
					  :page-size="10"
					  :small="screenWidth<785"
					  :pager-count="screenWidth>785?7:5"
					  :hide-on-single-page="true"
					  @current-change="pagechange"
					  layout="total, prev, pager, next"
					  :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<div :class="tops?'navbar':'navbar-top'" v-if="screenWidth>785" >
		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip>
		     <div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				
				<div  class="qrShow2 right2" v-if="showserviceQR">
					<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a>
		     <div  class="qrShow right" v-if="showQR">
							<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		    
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
		<!-- footer -->
		<div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;padding-top:20px;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="item in bottomnav" :key="item" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="item in bottomnav" :key="item" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
			<div class="row" :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'" >
				<!-- <div class="copy-left">
					<p><i class="el-icon-phone-outline"></i>{{pcsetdata.phone}}</p>
					<p><i class="el-icon-message"></i>{{pcsetdata.email}}</p>
					<p style="font-size: 13px;">地址信息：{{pcsetdata.address}}</p>
				</div> -->
				
				<div class="copy-left " :style="screenWidth>785?'':'width:40%;'" >
					<div class="bottom_logo"  v-if="screenWidth>785" >
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
				
			<!-- 		<div class="copy-right">
						<img src="../../../static/img/gzhsuncode.jpg" />
					</div> -->
				
				</div>
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'" abort="">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
	</div>
	
</template>

<script>
	import {  getNewslist, getCategory, getCamplist, getPc, getMapcamp, getRegion, getPlate,getbottomnav,getcamptags} from '@/request/api'
	
	export default {
	  name: "Camplist",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			  bottomnav:[],
			  top_search_url:'/Baselist',
			  manage_url:'/',
			  manageoptions:[
			  	{
			  	  value: '/',
			  	  label: '管理入口'
			  	}, {
			  	  value: 'https://yxwy.wanjiaxiao.cn/',
			  	  label: '机构管理后台'
			  	},
			  	 {
			  		value:'http://xh.wanjiaxiao.cn/seeyon/index.jsp',
			  		 label: '研学OA平台'
			  	 }
			  ],
			  stitle:'',
			  options: [{
			            value: '/Baselist',
			            label: '基地搜索'
			          },],
				platelist:[],
				activeIndex2: '/Baselist',
				phoneboxshow:false,
				userInfo: {
				  username: "",
				  education_name: "",
				  role_level: ""
				},
				logintype:true,
				banner:[
				],
				camptypes:[
					{ text: '全部', value: 0 },
					{ text: '基地', value: 2 },
					{ text: '营地', value: 1 },
				],
				camptype:2,
				camplist:[],
				quicklist:[],
				aclist:[],
				newsiconon:'',
				category_id:'',
				total:0,
				page_index:1,
				uuid:'',
				newsdata:{},
				pcsetdata:{},
				maplist:[],
				openmap:{},
				show: false,
				showinfowindow:false,
				regionlist:[],
				vanregionlist:[],
				camptags:[],
				vancamptags:[],
				tags_type:0,
				region_type:'',
				modules:'',
				showQR:false,
			 showserviceQR:false,
			  showofficialQR:false,
				tops:false,
				heights:window.innerHeight,
				scrolltop:'',
				//屏幕宽高
				// 屏幕宽度
				screenWidth: window.innerWidth,
				top_bannerWidth:Math.round(window.innerWidth/3.42),
				// 屏幕高度
				screenHeight: window.innerHeight,
				//手机端导航栏
				vannavshow:false,
				vannavlist:[
					{
						link:'/Home',
						text:'研学首页'
					},
					{
						link:'/Camplist',
						text:'营地列表'
					},
					{
						link:'/Newslist',
						text:'资讯资讯'
					},
					{
						link:'/Courselist',
						text:'研学课程'
					},
					{
						link:'/Activitylist',
						text:'研学活动'
					},
					{
						link:'/Linelist',
						text:'研学线路'
					},
					
					{
						link:'/mentorlist',
						text:'研学导师'
					},
					{
						link:'/expertlist',
						text:'专家团队'
					},
				],
		      }
	  },
	  beforeCreate(){
	  	   const loading = this.$loading({
	  	            lock: true,
	  	            text: '页面载入……',
	  	            // spinner: 'el-icon-loading',
	  	            background: '#ffffff'
	  	          });
	  },
	  created() {
		  this.getpcset()  
	  },
	  mounted() {
		  const { stitle } = this.$route.query;
		  this.stitle = stitle||''
		  this.getPlate()
		  var token = localStorage.getItem('token')||''
		   window.addEventListener('resize', this.handleResize, true)
		  this.token=token
		   // const { id } = this.$route.query;
		   // this.uuid = id
			this.getlist()
			 this.getbottomnav()
			this.getMapcamp()
			this.getRegion()
			this.getcamptags()
	  window.addEventListener('scroll', this.scrollToTop)
	  		
	  },
	   destroyed () {
	          window.removeEventListener('scroll', this.scrollToTop)
	    },
	  // 销毁监听
	  		beforeDestroy() {
	  		  window.removeEventListener('resize', this.handleResize);
	  		},
	  methods: {
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
	  		  vanlinkgo(e){
	  		  		  console.log(e)
	  		  		  this.$router.push({
	  		  		    path: e.link,
	  		  		    name: e.link,
	  		  		    query: {
	  		  		    }
	  		  		  }); 
	  		  },
	  		  vannavmenushow(){
	  		  		this.vannavshow=false  
	  		  },
	  		  handleResize() {
	  		  		   this.top_bannerWidth = 0;
	  		    this.screenWidth = window.innerWidth;
	  		  		this.top_bannerWidth=window.innerWidth/3.42
	  		  		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
	  		    this.screenHeight = window.innerHeight;
	  		  },
		  getcamptags(){
		  			var data={
		  				
		  			}  
		  			getcamptags(data).then(res=>{
		  				if(res.data.code==200){
							var list=[]
							for(var item of res.data.data){
								list.push({
									text:item.title,
									value:item.id
								})
							}
							this.vancamptags=list
		  					this.camptags=res.data.data
		  				}
		  			})
		  },
		  getbottomnav(){
		  		  var data={
		  			  page_index:1,
		  			  page_size:15,
						flag:99
		  		  }
		  		getbottomnav(data).then(res=>{
		  			this.bottomnav=res.data.data.list
		  		})  
		  },
		  gobottomnav(type,link){
		  		  if(type==1){
		  			  this.$router.push({
		  			  	path:link
		  			  });
		  		  }else if(type==2){
			  window.location.href = link;
		  }
		  },
		  logout(){
		  			  var that=this
		  			  this.$confirm('是否确认退出登录?', '提示', {
		  			  					confirmButtonText: '确定',
		  			  					cancelButtonText: '取消',
		  			  					type: 'warning'
		  			  }).then(() => {
		  						this.$alert("已退出登录", '', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								localStorage.setItem('token', '')
		  								localStorage.setItem('refreshToken', '')
		  								 that.$router.go(0)
		  							}
		  						  });
		  			  }).catch(() => {
		  			  		 
		  			  });
		  },
		  showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
		  			  this.showserviceQR=true
		  },
		  hideserviceQRCode(){//隐藏二维码
		      this.showserviceQR = false
		  },
		  showQRCode(){//显示二维码
		          this.showQR = true
		      },
		      hideQRCode(){//隐藏二维码
		          this.showQR = false
		      },
		      scrollToTop () {
		          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		          this.scrolltop = scrollTop
		          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		              this.tops = true
		          } else {
		              this.tops = false
		          }
		      },
		      gotop () {
		          let timer = setInterval(() => {
		              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		              if (this.scrolltop === 0) {
		                  clearInterval(timer)
		              }
		          }, 15)
		      },
		  showstep(ind) {
		       this.$refs.carousel.setActiveItem(ind)
		     },
		  		  goplate(id){
		  			  this.modules=id
		  			  this.page_index=1
		  			  this.getlist()
		  		  },
		  getPlate(){
		  		var data={
					flag:99
		  		}  
		  		getPlate(data).then(res=>{
		  			this.platelist=res.data.data
		  		})
		  },
		  showphonebox(){
		  		this.phoneboxshow=true  
		  },
		  closephonebox(){
		  		this.phoneboxshow=false  
		  },
		  goregister(e){
		  			  this.$router.push({
		  			    path: "/register",
		  			    name: "/register",
		  			  		  query: {
		  			  		  }
		  			  });
		  },
		  gohome(e) {
		    this.$router.push({
		      path: "/Home",
		      name: "/Home",
		  			  query: {
		  			  }
		    });
		  },
		  getRegion(){
		  			var data={}
		  			getRegion(data).then(res=>{
						var list=[
							{
								text:'全部地区',
								value:''
							}
						]
						for(var item of res.data.data){
							list.push({
								text:item.title,
								value:item.id
							})
						}
						this.vanregionlist=list
		  				this.regionlist=res.data.data
		  			})
		  },
		  getMapcamp(){
		  	var data={
		  		type:this.camptype,
		  	}
		  	getMapcamp(data).then(res=>{
		  		console.log(res)
		  	
		  		this.maplist=res.data.data
		  		this.openmap=res.data.data[0]
		  		const loading = this.$loading({
		  				 lock: true,
		  				text: '页面载入……',
		  				// spinner: 'el-icon-loading',
		  				background: '#ffffff'
		  			   });
		  		loading.close();
		  	})
		  },
		  infoWindowClose (index) {
		      this.showinfowindow = false
		  },
		  infoWindowOpen (index) {
		  	this.openmap=this.maplist[index]
		  	this.showinfowindow = true
		  	console.log(this.maplist[index])
		  },
	  		  getpcset(){
				var data={
				flag:99
			}
	  		  		getPc(data).then(res=>{
	  		  			this.pcsetdata=res.data.data
						// const loading = this.$loading({
						//          lock: true,
						//          text: 'Loading',
						//          spinner: 'el-icon-loading',
						//          background: 'rgba(0, 0, 0, 0.7)'
						//        });
						// loading.close();
	  		  		})  
	  		  },
		  camptypetab(val){
			  this.region_type=val
			  this.page_index=1
			  this.getlist()
		  },
		  pagechange(val){
		  			  this.page_index=val
		  			   this.getlist()
		  },
		  tagstypetab(val){
		  			  this.tags_type=val
		  			  this.page_index=1
		  			  this.getlist()
		  },
		  getlist(){
			var data={
				type:this.camptype,
				page_index: this.page_index,
				modules:this.modules,
					title:this.stitle,
				page_size: 10,
				region_type:this.region_type,
				tags:this.tags_type,
			}  
			getCamplist(data).then(res=>{
				console.log(res.data)
				this.camplist=res.data.data.list
				this.total=res.data.data.total
				// this.quicklist=res.data.data.list
			}).catch(error => {
				console.error(error);
			});
		  },
		  handleClick(e){
				console.log(e,this.category_id)
				 this._getNewslist()
		  },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			  var data={}
			  getCategory(data).then(res=>{
			    			  console.log(res.data)
			    			  this.types=res.data.data
							  this.category_id=res.data.data[0].id
							  this._getNewslist()
			    }).catch(error => {
			    			  console.error(error);
			    			});
		  },
		  /*
		   * 查看详情
		   * */
		  detail(e) {
		    this.$router.push({
		      path: "/CampDetails",
		      name: "CampDetails",
		      query: {
		        id: e
		      }
		    });
		  },
		gomodules(e){
			if(e){
				window.location.href = e;
			}
		},
	  }
	};
</script>

<style scoped>
	.bm-view {
	  width: 100%;
	  height: 450px;
	}
	.camplist{
		margin-top: 20px;
	}
	.campitems{
		margin-bottom: 20px;
		padding: 20px;
		background: #fff;
		transition: all .3s;
		-webkit-transition: all .3s;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.campitems:hover{
		box-shadow: 0 3px 20px rgba(0,200,169,.8);
	}
	.campitem_imgbox{
		position: relative;
		width: 337px;
		height: 161px;
		overflow: hidden;
	}
	.campitem_imgbox img{
		width: 100%;
		height: 100%;
	}
	.campitem_tags{
		position: absolute;
		    bottom: 0;
		    right: 0;
		    z-index: 1;
			display: flex;
			justify-content: flex-end;
			align-items: flex-end;
	}
	.campitem_tag{
		    height: 24px;
		    padding: 0 8px;
		    background: #FE7C2B;
		    color: #fff;
		    line-height: 24px;
		    font-size: 12px;
			margin-left: 5px;
	}
	.campitem_msg{
		width: 750px;
		height: 161px;
		display: flex;
		flex-direction: column;
			margin-left: 10px;
		/* justify-content: ; */
		
	}
	.campitem_msg_title{
		color: #FE7C2B;
		font-size: 18px;
		display: flex;
		align-items: center;
		padding: 0 10px 10px 0;
		border-bottom: 1px solid #e9e9e9;
		font-weight: 400;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		/* line-height: 24px; */
	}
	.campitem_msg_title span{
	/* 	    position: absolute;
		    top: 0;
		    left: 0; */
		    z-index: 1;
		    width: 60px;
		    height: 24px;
		    background: #FE7C2B;
		    color: #fff;
		    font-size: 14px;
		    text-align: center;
			    line-height: 24px;
			margin-right: 10px;
	}
	.campitem_msg_introduce{
		    line-height: 30px;
		    font-size: 16px;
		    /* padding-top: 15px; */
		    overflow: hidden;
			text-align: left;
			    display: flex;
			    align-items: center;
	}
	.campitem_msg_button{
		height: 42px;
		    /* margin-top: 15px; */
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
	}
	.msg_button{
		    z-index: 1;
		    width: 134px;
		    height: 34px;
		    background: #FE7C2B;
		    color: #fff;
		    line-height: 34px;
		    text-align: center;
		    border-radius: 4px;
	}
	
	.screen_box{
		margin-top: 30px;
		background: #fff;
		border: 1px solid #e9e9e9;
		border-bottom: 0;
		width: 100%;
		
	}
	.screen_items{
		width: 1100px;
		display: flex;
		flex-wrap: wrap;
		/* white-space: nowrap; */
		align-items: flex-start;
		/* overflow: scroll;   */
		overflow: auto;
		      white-space: nowrap;
		overflow-x: auto;
		overflow-y: hidden;
		
		/* padding-left: 134px; */
		
	
		border-bottom: 1px solid #e9e9e9;
		
	}
	.screen_title_box{
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
	}
	.screen_title{
		width: 120px;
		padding: 19px 0;
		text-align: center;
		background: #f4f4f4;
		flex-shrink: 0;
		flex-basis: auto;
		flex-grow: 0;
		display: inline-block;
	}
	.screen_item{
		width: 100px;
		margin: 13px 0 13px 15px;
		cursor: pointer;
		    height: 34px;
		    line-height: 34px;
		text-align: center;
		flex-shrink: 0;
		flex-basis: auto;
		flex-grow: 0;
		display: inline-block;
	}
	.screen_item_a{
		width: 100px;
		margin: 13px 0 13px 15px;
		cursor: pointer;
		    height: 34px;
		    line-height: 34px;
		text-align: center;
		    background: #FE7C2B;
		    color: #fff;
			flex-shrink: 0;
			flex-basis: auto;
			flex-grow: 0;
			display: inline-block;
			
	}
	.screen_item:hover{
		background: #FE7C2B;
		color: #fff;
	}
	
</style>